import { render, staticRenderFns } from "./BomSelect.vue?vue&type=template&id=4211f11f&"
import script from "./BomSelect.vue?vue&type=script&lang=js&"
export * from "./BomSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports